// "Encaixes" que outras fatias preenchem sem editar o AppLayout:
//  - SuggestionsBadge: contador de sugestões no menu (fatia S3b)
//  - AssistantButton: botão + painel do assistente de IA (fatia S4)
//  - NotificationsBell: sino de notificações (fatia S5b)
import type { ComponentType } from 'react'
import SuggestionsBadge from '../features/recommendations/SuggestionsBadge'
import AssistantButton from '../features/assistant/AssistantButton'
import NotificationsBell from '../features/notifications/NotificationsBell'

export const slots: {
  SuggestionsBadge: ComponentType<{ companyId: string }> | null
  AssistantButton: ComponentType<{ companyId: string }> | null
  NotificationsBell: ComponentType | null
} = { SuggestionsBadge, AssistantButton, NotificationsBell }
